export const pricingTabsArticle = {
  title: 'Pricing Intelligence Suite: Hub Tabs',
  slug: 'pricing-intelligence-tabs',
  content: `Pricing Intelligence Suite: Hub Tabs

Each tab focuses on a different pricing workflow.

1) Price Calculator
- Model prices based on revenue targets.

2) Margin Analysis
- Compare margins across products or packages.

3) AI Strategy
- Draft pricing strategy guidance.

Tip
- Use URL hashes (#calculator, #margin, #strategy) to open tabs directly.
`,
};
